import { render, staticRenderFns } from "./AddCommentDialog.vue?vue&type=template&id=06400138&"
import script from "./AddCommentDialog.vue?vue&type=script&lang=js&"
export * from "./AddCommentDialog.vue?vue&type=script&lang=js&"
import style0 from "@/assets/sass/components/dialogs/add-comment-dialog.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports